export default __webpack_public_path__ + "static/media/caroline.e56b5362.jpeg";